import { LogOut, Settings, UserCircle, Info } from 'lucide-react';

import type { AppDispatch } from '@/app/types';
import { logout, authApi } from '@/entities/auth';

import { RouteNames } from '@/shared/config/routes';
import { MODAL_QUERY_PARAM, ModalKeys } from '@/shared/config/modals';

import type { MenuAction } from './types';

export const createMenuActions = (dispatch: AppDispatch, navigate: (path: string) => void): MenuAction[] => [
  {
    id: 'profile',
    label: 'Profile',
    labelKey: 'userMenu.profile',
    icon: UserCircle,
    hotkey: { key: 'p', shift: true, meta: true },
    handler: () => {
      const currentPath = window.location.pathname;
      const currentSearch = new URLSearchParams(window.location.search);
      currentSearch.set(MODAL_QUERY_PARAM, ModalKeys.CHANGE_PASSWORD);
      navigate(`${currentPath}?${currentSearch.toString()}`);
    }
  },
  {
    id: 'settings',
    label: 'Settings',
    labelKey: 'userMenu.settings',
    icon: Settings,
    hotkey: { key: 's', meta: true },
    handler: () => {
      const currentPath = window.location.pathname;
      const currentSearch = new URLSearchParams(window.location.search);
      currentSearch.set(MODAL_QUERY_PARAM, ModalKeys.PREFERENCES);
      navigate(`${currentPath}?${currentSearch.toString()}`);
    }
  },
  {
    id: 'about',
    label: 'About',
    labelKey: 'gen.about.label',
    icon: Info,
    hotkey: { key: 'i', shift: true, meta: true },
    handler: () => {
      const currentPath = window.location.pathname;
      const currentSearch = new URLSearchParams(window.location.search);
      currentSearch.set(MODAL_QUERY_PARAM, ModalKeys.ABOUT);
      navigate(`${currentPath}?${currentSearch.toString()}`);
    }
  },
  {
    id: 'logout',
    label: 'Log out',
    labelKey: 'userMenu.logout',
    icon: LogOut,
    hotkey: { key: 'l', meta: true },
    handler: () => {
      dispatch(authApi.endpoints.logout.initiate());
      dispatch(logout());
      navigate(RouteNames.LOGIN);
    },
    variant: 'destructive',
    separator: 'before'
  }
];
